import { atom } from "jotai";

export const buildZapSkeletonToolsAtom = atom([]);
buildZapSkeletonToolsAtom.debugLabel = "buildZapSkeletonToolsAtom";

export const buildZapSkeleton = `
## How to Build a Zap Skeleton 

This will provide the minimum required fields to define the base skeleton. This will not include any data unique to the user. That data will be populated in another process.

## Example skeleton - this is a valid ZAP SCHEMA AND YOU SHOULD USE THIS AS A REFERENCE

{
  "id": "_GEN_ROOT",
  "zdl": {
    "app": "EngineAPI",
    "type": "run",
    "action": "series_skip_errors",
    "timezone": "America/New_York",
    "zdl_version": "0.4",
    "title": "Untitled Zap",
    "steps": [
      {
        "id": "_GEN_1",
        "app": "ABC@1.19.0",
        "type": "read",
        "action": "new_record",
        "params": {},
        "meta": {}
      },
      {
        "id": "_GEN_2",
        "app": "XYZ@1.9.0",
        "type": "write",
        "action": "detailed_event",
        "params": {},
        "meta": {}
      }
    ]
  },
}

When creating zaps programmatically:
- ALWAYS create zap skeletons with empty params and meta objects: \`"params": {}\` and \`"meta": {}\`
- NEVER set \`app_id\` on the steps - this is for configuration later
- NEVER populate params or meta during initial zap creation - this is for configuration later
- The initial zap creation is only for establishing the workflow structure
- Field mapping and parameter configuration happens in subsequent steps - it is not part of this recipe
- When creating a zap, always send id: _GEN_ROOT. Don't forget it!

**Example correct zap creation structure:**

1. call the /v4/implementations-meta/search API to find the most relevant app. Use search_tool to find it.
2. Find current_implementation_id on the most relevant app returned. This is what you will set for the \`app\` field on the zap.
3. Query api/v4/implementations?selected_apis=$current_implementation_id (use your own current_implementation_id based on the result of step 2). If you need details on how to call this api, use the search_tool.
4. Find the most relevant implementation returned. Look at the implementations \`actions\` field to determine what triggers and actions are available.
5. Once you find the best action, set the \`key\` field from the action on the zap step's \`action\` field.

Repeat the above per step on the zap until the skeleton is complete.

## Once you have the steps setup

Make sure that when you save this zap, you follow the schema for what a zap object looks like. 
`;
